.emptyTreePlaceholder {
  padding-top: 6.3rem;
  align-items: flex-start;
}
